@if (allowedTypes.includes(CommentType.PersonalNote)) {
  <button ttButton [variant]="'transparent'" (click)="popoverRef.close(CommentType.PersonalNote)">
    <mat-icon [icon]="'notebook-pen'" />
    {{ 'Comments.PersonalNoteShort' | transloco }}
  </button>
}
@if (allowedTypes.includes(CommentType.ReaderFeedback)) {
  <button
    ttButton
    [class.tt-add-comment-popover_divided]="allowedTypes.includes(CommentType.PersonalNote)"
    [variant]="'transparent'"
    (click)="popoverRef.close(CommentType.ReaderFeedback)">
    <mat-icon [icon]="'message-square-text'" />
    {{ 'Comments.FeedbackShort' | transloco }}
  </button>
}
@if (allowedTypes.includes(CommentType.Comment)) {
  <button ttButton [variant]="'transparent'" (click)="popoverRef.close(CommentType.Comment)">
    <mat-icon [icon]="'message-square-text'" />
    {{ 'Comments.AddComment' | transloco }}
  </button>
}
